<template>
  <div class="outdiv">
    <div class="agreement">
      <header class="header van-hairline--bottom">
        <span>{{ agreement.popupTitle }}</span>
      </header>
      <div
        v-html="agreement.popupContent"
        class="bodyAgreement"
        :class="{
          'img-xieyi': agreement.popupTitle == '实名制公告',
        }"
      ></div>
    </div>
    <div @click="cancelPopup" class="closebtn">
      <img
        src="~@/assets/images/closeImg.png"
        alt=""
        class="cancel"
        style="width: 0.64rem;height: auto;"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: "XXX",
    },
    agreement: {},
  },
  data() {
    return {
      json: ``,
    };
  },
  mounted() {},
  methods: {
    cancelPopup() {
      this.$emit("cancelPopup", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.outdiv {
  position: relative;
  padding: 0 10px;
  box-sizing: border-box;
  .agreement {
    background: #fff;
    padding-bottom: 10px;
    border-radius: 5px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      height: 40px;
      span {
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        color: #505050;
        margin: 0;
      }
    }
    .bodyAgreement {
      font-size: 12px;
      max-height: 310px;
      overflow-y: auto;
      padding: 20px;
      text-indent: 2em;
      line-height: 20px;
      &.img-xieyi {
        padding: 0px !important;
        text-indent: 0em !important;
        text-align: center;
      }
      -webkit-overflow-scrolling: touch;
      color: #505050;

      // width: 100%;
    }
  }
  .closebtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.agreeDialog-container {
  padding: 0.533333rem;
  .h1 {
    padding-bottom: 0.4rem;
    font-size: 0.533333rem;
    font-weight: 600;
  }
  .agreeDialog-content {
    max-height: 70vh;
    overflow-y: scroll;
    p {
      font-size: 0.373333rem;
      color: #333;
      line-height: 0.666667rem;
      &:first-of-type {
        text-indent: 1.5em;
      }
    }
  }
}
</style>
